'use client';
import React__default, { forwardRef, useRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { Modal as Modal$1 } from './Modal.styles.js';
import useDialog from '../../hooks/useDialog.js';
import { FlyoutProvider } from '../Flyout/FlyoutContext.js';

var defaultProps = {
  isDisabledEscape: false,
  isOpen: false,
  onCancel: undefined,
  onConfirm: function onConfirm() {},
  onEscape: undefined,
  testId: undefined
};
var Modal = forwardRef(function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultProps,
    children = _ref.children,
    id = _ref.id,
    isDisabledEscape = _ref.isDisabledEscape,
    isOpen = _ref.isOpen,
    onCancel = _ref.onCancel,
    onConfirm = _ref.onConfirm,
    onEscape = _ref.onEscape,
    testId = _ref.testId;
  var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var dialogRef = useRef(null);
  var onEscapeCallback = onEscape || onCancel || onConfirm;
  var _useDialog = useDialog({
      dialogRef: dialogRef,
      isDisabledEscape: isDisabledEscape,
      isOpen: isOpen,
      onEscapeCallback: onEscapeCallback
    }),
    handleClick = _useDialog.handleClick;
  useImperativeHandle(ref, function () {
    return dialogRef.current;
  });
  return React__default.createElement(Modal$1, {
    "aria-labelledby": id,
    onClick: handleClick,
    ref: dialogRef,
    role: "dialog",
    tabIndex: "-1",
    "data-testid": testId
  }, React__default.createElement(FlyoutProvider, {
    value: dialogRef
  }, children));
});
Modal.defaultProps = defaultProps;
Modal.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  isDisabledEscape: PropTypes.bool,
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  onEscape: PropTypes.func,
  testId: PropTypes.string
};

export { Modal };
//# sourceMappingURL=Modal.js.map
